import React, { useCallback, useState } from 'react';
import { Button, Outside } from '@cian/ui-kit';

import { Textarea } from '../Textarea';
import { PostCommentsNotifySwitcher } from '../PostCommentsNotifySwitcher';
import * as s from './PostCommentForm.css';

export interface IPostCommentForm {
  value: string;
  onSubmit(): void;
  onChange(value: string): void;
}

/**
 * Форма для отправки комментария
 */
export const PostCommentForm = ({ value, onChange, onSubmit }: IPostCommentForm) => {
  const [isActivated, setIsActivated] = useState<boolean>(false);

  const toggleActivation = useCallback(
    isActivated => {
      setIsActivated(isActivated);
    },
    [setIsActivated],
  );

  return (
    <Outside active onOutside={() => toggleActivation(false)} insideRefs={[]}>
      <div className={s['wrapper']}>
        <Textarea
          hasCounter={isActivated}
          placeholder="Прокомментировать"
          maxLength={300}
          size={'M'}
          value={value}
          onChange={(e, value) => onChange(value)}
          onFocus={() => toggleActivation(true)}
          minRows={isActivated ? 3 : undefined}
          maxRows={isActivated ? undefined : 1}
        />

        <div className={`${s['controls']} ${isActivated ? s['_shown'] : ''}`}>
          <div className={s['controls-wrapper']}>
            <Button onClick={onSubmit}>Опубликовать</Button>
            <PostCommentsNotifySwitcher onChange={() => {}} />
          </div>
        </div>
      </div>
    </Outside>
  );
};
